import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="site-brand" aria-label="Avto Tarix">
          <span className="site-brand__mark">Avto Tarix</span>
          <span className="site-brand__dot" aria-hidden="true" />
          <span className="site-brand__tld">.uz</span>
        </Link>

        <div className="site-nav">
          <Link to="/" className={`site-nav__link${isActive('/') ? ' is-active' : ''}`}>
            {t('header.home')}
          </Link>
          <Link to="/search" className={`site-nav__link${isActive('/search') ? ' is-active' : ''}`}>
            {t('header.search')}
          </Link>
          <Link to="/add" className={`site-nav__link${isActive('/add') ? ' is-active' : ''}`}>
            {t('header.add')}
          </Link>
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};

export default Header;
